import { render } from "./ChatRateDialog.vue?vue&type=template&id=3e3c86a2&scoped=true"
import script from "./ChatRateDialog.vue?vue&type=script&lang=js"
export * from "./ChatRateDialog.vue?vue&type=script&lang=js"

import "./ChatRateDialog.vue?vue&type=style&index=0&id=3e3c86a2&lang=scss&scoped=true"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e3c86a2"]])

export default __exports__